import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import RedEnvelopeOutlinedSvg from "@ant-design/icons-svg/es/asn/RedEnvelopeOutlined";
import AntdIcon from "../components/AntdIcon";
var RedEnvelopeOutlined = function RedEnvelopeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RedEnvelopeOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  RedEnvelopeOutlined.displayName = 'RedEnvelopeOutlined';
}
export default /*#__PURE__*/React.forwardRef(RedEnvelopeOutlined);